export const CARD_STYLES = ['sunset', 'aurora', 'mint', 'lagoon'];

export const CARD_GRADIENTS = {
  sunset: 'linear-gradient(135deg, #f857a6 15%, #ff9a6b 50%, #7ad7f0 85%)',
  aurora: 'linear-gradient(135deg, #c56cf0 15%, #ff8fb1 50%, #ffd86b 85%)',
  mint: 'linear-gradient(135deg, #43e97b 15%, #38c9d6 85%)',
  lagoon: 'linear-gradient(135deg, #7367f0 15%, #5b8def 50%, #34e0c9 85%)',
};
